import { Route } from '@angular/router';
import { NotFoundComponent } from '../shared-module/cpq-not-found/cpq-not-found.component';
import { TranslationsResolverService } from '../shared-module/common/resolvers/translations-resolver.service';
import { PlaybookComponent } from '../playbook-module/playbook.component';
import { DevelopmentGuard } from '../shared-module/common/guards/development-guard.service';

/**
Admin Segregation - Create script for inserting new page into segregation.
Example : INSERT INTO sys_MenuLinkInfo ([Key], [Url],[GroupId], [Label])
VALUES ('21.6', 'security/certificate-management',21, 'xmlCertificateManagement')
GO
*/
export const ROUTES: Route[] = [
  // TODO for now we will login user on home path webcomcpq.com/SetupSpa/{
  {
    path: 'setup-home',
    loadChildren: () => import('app/setup-home-module/setup-home.module').then(m => m.SetupHomeModule),
    data: { path: 'setup-home' }, // path is used in TranslationsResolverService
    resolve: { translations: TranslationsResolverService },
  },
  {
    path: 'users',
    loadChildren: () => import('app/users-module/users.module').then(m => m.UsersModule),
    data: { path: 'users' }, // path is used in TranslationsResolverService
    resolve: { translations: TranslationsResolverService },
  },
  {
    path: 'quote',
    loadChildren: () => import('app/quote-module/quote.module').then(m => m.QuoteModule),
    data: { path: 'quote' }, // path is used in TranslationsResolverService
    resolve: { translations: TranslationsResolverService },
  },
  {
    path: 'business-partners',
    loadChildren: () => import('app/business-partners-module/business-partners.module').then(m => m.BusinessPartnersModule),
    data: { path: 'business-partners' }, // path is used in TranslationsResolverService
    resolve: { translations: TranslationsResolverService },
  },
  {
    path: 'developer-tools',
    loadChildren: () => import('app/developer-tools-module/developer-tools.module').then(m => m.DeveloperToolsModule),
    data: { path: 'developer-tools' },
    resolve: { translations: TranslationsResolverService },
  },
  {
    path: 'products',
    loadChildren: () => import('app/product-module/product.module').then(m => m.ProductModule),
    data: { path: 'products' }, // path is used in TranslationsResolverService
    resolve: { translations: TranslationsResolverService },
  },
  {
    path: 'pricing-calculations',
    loadChildren: () => import('app/pricing-calculations-module/pricing-calculations.module').then(m => m.PricingCalculationsModule),
    data: { path: 'pricing-calculations' }, // path is used in TranslationsResolverService
    resolve: { translations: TranslationsResolverService },
  },
  {
    path: 'providers',
    loadChildren: () => import('app/providers-module/providers.module').then(m => m.ProvidersModule),
    data: { path: 'providers' }, // path is used in TranslationsResolverService
    resolve: { translations: TranslationsResolverService },
  },
  {
  path: 'develop',
  loadChildren: () => import('app/develop-module/develop.module').then(m => m.DevelopModule),
  data: { path: 'develop' }, // path is used in TranslationsResolverService
  resolve: { translations: TranslationsResolverService },
  },
  {
    path: 'security',
    loadChildren: () => import('app/security-module/security.module').then(m => m.SecurityModule),
    data: { path: 'security' }, // path is used in TranslationsResolverService
    resolve: { translations: TranslationsResolverService },
  },
  {
    path: 'audit-trail',
    loadChildren: () => import('app/audit-trail-module/audit-trail.module').then(m => m.AuditTrailModule),
    data: { path: 'audit-trail' }, // path is used in TranslationsResolverService
    resolve: { translations: TranslationsResolverService },
  },
  {
    path: 'ui-design',
    loadChildren: () => import('app/ui-design-module/ui-design.module').then(m => m.UiDesignModule),
    data: { path: 'ui-design' }, // path is used in TranslationsResolverService
    resolve: { translations: TranslationsResolverService },
  },
  {
    path: 'workflow-approval',
    loadChildren: () => import('app/workflow-approval-module/workflow-approval.module').then(m => m.WorkflowApprovalModule),
    data: { path: 'workflow-approval' }, // path is used in TranslationsResolverService
    resolve: { translations: TranslationsResolverService },
  },
  {
    path: 'import-export',
    loadChildren: () => import('app/import-export-module/import-export.module').then(m => m.ImportExportModule),
    data: { path: 'import-export' }, // path is used in TranslationsResolverService
    resolve: { translations: TranslationsResolverService },
  },
  {
    path: 'playbook',
    component: PlaybookComponent,
    canActivate: [DevelopmentGuard]
  },
  {
    path: 'general',
    loadChildren: () => import('app/general-module/general.module').then(m => m.GeneralModule),
    data: { path: 'general' }, // path is used in TranslationsResolverService
    resolve: { translations: TranslationsResolverService },
  },
  {
    path: 'sales-area',
    loadChildren: () => import('app/sales-area-module/sales-area.module').then(m => m.SalesAreaModule),
    data: { path: 'sales-area' }, // path is used in TranslationsResolverService
    resolve: { translations: TranslationsResolverService },
  },
  {
    path: '**',
    component: NotFoundComponent,
    data: { title: 'Error404.Message', path: '404' }, // path is used in TranslationsResolverService
    resolve: { translations: TranslationsResolverService },
  }
];
